export default "__VITE_ASSET__BMMlkoVE__"